import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ResponseModel } from '../../../shared/models/response-model.model';
import { DataService } from '../../../shared/services/data.service';
import {  InsertUpdateSchemeModel } from './investment-fund.model';
import { PaginationModel } from 'src/app/shared/common-components/ag-grid/ag-grid.model';
import { InsertNormaltabData, InstallmentEntryModel } from './installment-entry/installment-entry.model';
@Injectable({
  providedIn: 'root'
})
export class InvestmentFundService {
  getAllReciptDetails(pagination: PaginationModel) {
    throw new Error('Method not implemented.');
  }

  constructor(
    public service:DataService,
    ) {}
    getAllSchemeDetails(data:any): Observable<ResponseModel> {
      let url = "api/app/investmentfund/getallschemedetails";
      return this.service.post(url,data,true).pipe<ResponseModel>(
        tap((response: any) => {
          return response;
        })
      );
    }
    insertSchemeDetails(insertUpdateSchemeModel :InsertUpdateSchemeModel):Observable<ResponseModel>{
        let url = "api/app/investmentfund/insertschemedetail";
        const json =JSON.stringify(insertUpdateSchemeModel)
        return this.service.post(url, insertUpdateSchemeModel,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }
    updateSchemeDetails(data :InsertUpdateSchemeModel):Observable<ResponseModel>{
        let url = "api/app/investmentfund/updateschemedetail";
        const json =JSON.stringify(data)
        return this.service.post(url, data,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
    }
    getSchemeDetailId(id:string){
        let url = `api/app/investmentfund/getschemedetailbyid?Id=${id}`;
        return this.service.get(url,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }

      deleteSchemeDetail(id:number):Observable<ResponseModel>{
        let url = `api/app/investmentfund/deleteschemedetail?Id=${id}`;
        return this.service.delete(url, true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }

      GetallinstallmentfunddetailsData(requestModel : PaginationModel){
        let url = "api/app/installmentfund/getallinstallmentfunddetails";
        return this.service.post(url,requestModel,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
       
      }

      getByIdmentfunddetailsData(investmentFundId:number,schemeId:number){
        let url =`api/app/installmentfundentries/getinstallmentfundentriesbyschemeandinvestfundid?investmentFundId=${investmentFundId}&schemeId=${schemeId}`;
        return this.service.get(url,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }

      insertinstallmentfundentries(data:any){
        let url ='api/app/installmentfundentries/insertinstallmentfundentries';
        return this.service.post(url,data,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }
      Getschemedetailbyid(id:number){
        let url = `api/app/investmentfund/getschemedetailbyid?Id=${id}`;
        return this.service.get(url,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }

      InsertinstallmentfundData(data:InstallmentEntryModel){
        let url = 'api/app/installmentfund/insertinstallmentfund';
        return this.service.post(url, data,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }

      InsertNormalTabData(data:InsertNormaltabData){
        let url = 'api/app/installmentfundentries/insertinstallmentfundentries';
        return this.service.post(url, data,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }
      getReceiptData(id , paymentMasterId){
        let url = `api/app/installmentfundentries/getreceiptbyinstallmentfundentriesid?installmentFundEntryId=${id}&paymentMasterId=${paymentMasterId}`;
        return this.service.get(url,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }
      UpdateInstallmentFundEntries(data:any){
        let url ='api/app/installmentfundentries/updateinstallmentfundentries';
        return this.service.post(url, data,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }
      DeleteInstallmentFundEntries(id:number):Observable<ResponseModel>{
        let url = `api/app/installmentfundentries/deleteinstallmentfundentries?Id=${id}`;
        return this.service.delete(url, true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }
      
      insertfundtransferandwithdraw(data:any){
        let url = 'api/app/installmentfundentries/insertfundtransferandwithdraw';
        var json = JSON.stringify(data);
        return this.service.post(url,data,false).pipe<ResponseModel>(tap((response: any) => {
          return response;
          })
        );
      }
      
      Getfundwithdrawbyid(id:number){
        let url = `api/app/installmentfundentries/getfundwithdrawbyid?Id=${id}`;
        return this.service.get(url,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }

      Getfundtransferbyid(id:number){
        let url = `api/app/installmentfundentries/getfundtransferbyid?Id=${id}`;
        return this.service.get(url,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }
      updatelayawaysstatus(data:any):Observable<ResponseModel>{
        let url = "api/app/layawaysreport/updatelayawaysstatus";
        return this.service.post(url, data,true).pipe<ResponseModel>(
          tap((response: any) => {
            return response;
          })
        );
      }
      getAllLayawaysReport(data:any){
        let url = 'api/app/layawaysreport/getalllayawaysreportdata';
        return this.service.post(url,data,false).pipe<ResponseModel>(tap((response: any) => {
          return response;
          })
        );
      }
    }